var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoFire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 5.99968C13.5 7.49968 13 9.49967 10.6 10.2997C11.3 8.59968 11.4 6.89968 10.9 5.29968C10.2 3.19968 7.9 1.59968 6.3 0.699675C5.9 0.399675 5.2 0.799675 5.3 1.39968C5.3 2.49968 5 4.09968 3.3 5.79968C1.1 7.99968 0 10.2997 0 12.4997C0 15.3997 2 18.9997 6 18.9997C2 14.9997 5 11.4997 5 11.4997C5.8 17.3997 10 18.9997 12 18.9997C13.7 18.9997 17 17.7997 17 12.5997C17 9.49968 15.7 7.09968 14.6 5.69968C14.3 5.19968 13.6 5.49968 13.5 5.99968Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFire);
export default __webpack_public_path__ + "static/media/ico-fire.aaeff398df438e9d9a05e671ea6eda7e.svg";
export { ForwardRef as ReactComponent };